import { Button, Checkbox, FormControlLabel, Grid, TextField } from '@material-ui/core';
import React from 'react';
import { clientAutocomplete } from '../../../../autocomplete';
import AutocompleteSelect from '../../../../components/atom/AutocompleteSelect';
import FilterRangePicker from '../../../../components/atom/FilterRangePicker';

const PayoutReportsFilter = ({ filters, setFilters, generateReport, exportXlsx }) => {
    return (
        <Grid
            item
            container
            id="golf-sidemenu"
            className="golf-reservation is-open"
            lg={3}
            sm={4}
            xs={12}
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            style={{ margin: 0 }}
        >
            <Grid item container className="title" justifyContent="flex-start">
                Payout reports
            </Grid>
            <AutocompleteSelect
                style={{ width: '260px', margin: '10px' }}
                initCall={clientAutocomplete.init}
                autocompleteCall={clientAutocomplete.search}
                value={filters.clientId}
                setValue={clientId => {
                    setFilters({
                        ...filters,
                        clientId
                    });
                }}
                className="mb-2"
            >
                <TextField placeholder="Leave empty for system" />
            </AutocompleteSelect>
            <FilterRangePicker
                filters={filters}
                setFilters={setFilters}
                disablePast={false}
                fromKey="startDate"
                toKey="endDate"
            />
            <Button
                variant="outlined"
                size="medium"
                style={{ margin: '10px' }}
                onClick={() => setFilters({ ...filters, startDate: null, endDate: null })}
            >
                Reset dates
            </Button>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={filters.groupActivities}
                        onChange={() =>
                            setFilters({
                                ...filters,
                                groupActivities: !filters.groupActivities
                            })
                        }
                    />
                }
                label="Group payouts by activities"
            />
            <Button
                variant="contained"
                color="primary"
                size="medium"
                style={{ margin: '10px' }}
                onClick={() => generateReport()}
            >
                Generate report
            </Button>
            <Button variant="contained" size="small" onClick={exportXlsx}>
                Export to XLSX
            </Button>
        </Grid>
    );
};

export default PayoutReportsFilter;
